import { ApplicationCode } from '@ph-env/model/applications.models';

import { Role } from '@ph-core/enums/role.enum';
import {
  AllDealers,
  AvailableProduct,
  AvailableProductText,
  DealerInfo,
  Markup,
  Menu,
  PendingDays,
  SiteInfo,
} from '@ph-model/login/index';

import { AccessScope } from './access-scopes';
import { SortOptionIdEnum } from '@ph-shopping/model/sort-option';
import { ProductViewType } from '@ph-core/enums/product-view-type';

export class UserResponse {
  actualDealerGroup: string = '';
  agentCode: string = '';
  aggregateService?: boolean;
  aggregatorURL: string = '';
  allDealers: AllDealers[] = [];
  application: ApplicationCode = '' as ApplicationCode;
  applicationId: string = '';
  applicationName: string = '';
  authenticated: boolean = false;
  availableProducts: AvailableProduct[] = [];
  availableProductText: AvailableProductText = {} as AvailableProductText;
  bypassAggregator: boolean = false;
  cancellationURL: string = '';
  cmsDealerNumber: string = '';
  compliance: boolean = false;
  complianceId: string = '';
  dealerInfo: DealerInfo = {} as DealerInfo;
  defaultGetProduct: string = '';
  defaultSaveProduct: string = '';
  disableSaveQuote: boolean = false;
  displayProblem: boolean = false;
  emailId: string = '';
  fullName: string = '';
  isRelatedDealer: boolean = false;
  isTempPassword: string = '';
  languageCode: string = '';
  languageId: string = '';
  menus: Menu[] = [];
  message: string = '';
  name: string = '';
  pendingContracts: number = 0;
  pendingDays: PendingDays = {} as PendingDays;
  preferredLanguage: string = '';
  productCategory: { [key: string]: string } = {};
  programDefaults: {
    markup: Markup;
    linkCard: { displayName: string; id: string }[];
    languageCode: string;
    sortBy: SortOptionIdEnum;
    dealerView: ProductViewType;
  } = {
    markup: new Markup(),
    linkCard: [],
    languageCode: '',
    sortBy: SortOptionIdEnum.ProductAsc,
    dealerView: ProductViewType.Customer,
  };
  programId: string = '';
  relatedApplicationId: string = '';
  resourceView: string = '';
  roleIds: string[] = [];
  roles: Role[] = [];
  scopes: AccessScope[] = [];
  siteInfo: SiteInfo = {} as SiteInfo;
  status: boolean = false;
  token?: string;
  useDealerGroup: boolean = false;
  userDefaults: { markup: Markup };
  userName: string = '';

  constructor() {
    this.userDefaults = {
      markup: new Markup(),
    };
  }
}
